import { getBackendUrl } from "@Utils";
import { useTranslation } from "@i18n";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import { useRef, useState } from "react";
import DetailsIcon from "@Components/StickySidebarViewer/assets/Details";
import { convertDate } from "@Services/luxonHelper";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { statusCategories } from "@Features/portal-settings";
import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";

function FilePropertiesInReviews({ fileName, fileType, fileVersionNumber, size, statuses, closeProperties }: any) {
  const { t } = useTranslation();
  const [accordionState, setAccordionState] = useState({
    details: true,
    status: true,
  });
  const menuBtnRef = useRef<any>(null);

  const menuItems: any[] = [{ id: "1", text: "Close" }];

  const selectItem = (e: any) => {
    if (e.item.id === "1") {
      closeProperties();
    }
  };

  const getDropdownCategoryStyles = (category: any) => {
    if (category === null) {
      return { backgroundColor: "#ecf3fe" };
    }

    const matchedCategory = statusCategories.find((record: any) => record.name === category);
    const backgroundColor = matchedCategory ? matchedCategory.backgroundHexcode : "#0006A2";

    const style = { backgroundColor };
    return style;
  };

  const getFormattedDate = (date: any) => {
    if (date) {
      return convertDate(Number(date), "dateForText");
    }

    return "-";
  };

  const getSignatureBtn = (signatureId: any) => {
    let url: any = void 0;
    let target = "_self";

    if (signatureId) {
      url = `${getBackendUrl()}/fileSystemServer/getSignDocs/${signatureId}`;
      target = "_blank";
    }

    return (
      <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
        <a href={url} target={target}>
          {t("View E-Signature")}
        </a>
      </ButtonComponent>
    );
  };

  const getUserNameComponent = (user: any) => (
    <div>
      <UserNameTagComponent id={user.userId} />
    </div>
  );

  const detailsHeader = () => (
    <div className="py-2.5 px-4 flex flex-row items-center justify-start gap-2 [&_span]:font-bold [&_span]:text-base">
      <DetailsIcon size="24" color="#192048" />
      <span>{t("Details")}</span>
    </div>
  );

  const detailsContent = () => (
    <div className="pb-6 ps-4">
      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Name")}</span>
        <span>{fileName}</span>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("File Type")}</span>
        <span>{fileType}</span>
      </div>

      <div className="flex flex-row items-center justify-between py-3">
        <span className="text-base font-semibold">{t("Size")}</span>
        <span>{size}</span>
      </div>
    </div>
  );

  const statusHeader = () => (
    <div className="py-2.5 px-4 flex flex-row items-center justify-start gap-2 [&_span]:font-bold [&_span]:text-base">
      <DetailsIcon size="24" color="#192048" />
      <span>{t("Status")}</span>
    </div>
  );

  const statusContent = () => (
    <div className="pb-6 ps-4">
      {statuses.length > 1 ? (
        statuses.map((status: any, index: number) => {
          if (index) {
            const { name, category, createdDate, createdBy, comment, signatureId } = status;

            const lastStatus = statuses[index - 1];

            const currentStatusStyle = getDropdownCategoryStyles(category);
            const lastStatusStyle = getDropdownCategoryStyles(lastStatus.category);

            return (
              <div key={index} className="flex flex-col gap-3 pb-8">
                <div className="flex flex-row items-center justify-start gap-2 py-0.5">
                  <p>{t("Status changed")}</p>
                  {index > 1 && <p>{t("from")}</p>}
                  {index > 1 && (
                    <span
                      className="text-sm py-1.5 px-4 rounded border-0 text-white font-[var(--font-weight-600)]"
                      style={lastStatusStyle}
                    >
                      {lastStatus.name}
                    </span>
                  )}
                  <p>{t("to")}</p>
                  <span
                    className="text-sm py-1.5 px-4 rounded border-0 text-white font-[var(--font-weight-600)]"
                    style={currentStatusStyle}
                  >
                    {name}
                  </span>
                </div>

                <div className="flex flex-row items-center justify-start gap-2 py-0.5">
                  <p>{t("By")}</p>
                  {getUserNameComponent(createdBy)}
                  <p>{t("on")}</p>
                  <p className="font-[var(--font-weight-700)] text-base">{getFormattedDate(createdDate)}</p>
                </div>

                <div className="p-2 bg-[#f0f5f9] rounded text-sm">{comment}</div>

                <div>{getSignatureBtn(signatureId)}</div>
              </div>
            );
          }
        })
      ) : (
        <p>{t("There has not been any activity about changing status of the file")}</p>
      )}
    </div>
  );

  return (
    <div className="flex flex-col w-[43.75rem] overflow-auto h-full">
      <div className="py-4 pe-6 ps-8 border-b-0.5 border-[#ecf3fe]">
        <div className="flex flex-row items-center justify-end">
          <SelectDropDown select={selectItem} ref={menuBtnRef} items={menuItems} cssClass="e-caret-hide border-0 ms-6">
            <span className="e-more-vertical-1 e-icons" />
          </SelectDropDown>
        </div>

        <div className="py-2 flex flex-row gap-4 items-center justify-start [&_p]:text-2xl [&_p]:font-[var(--font-weight-600)] [&_p]:max-w-[15.625rem] [&_p]:text-ellipsis [&_p]:whitespace-nowrap [&_p]:overflow-hidden [&_span]:py-1 [&_span]:px-2 [&_span]:rounded [&_span]:bg-[#ecf3fe]">
          {/* <img /> */}
          <p>{fileName}</p>
          <span>{fileVersionNumber}</span>
        </div>
      </div>
      <div className="overflow-auto">
        <Accordion
          disableGutters
          expanded={accordionState.details}
          onChange={() => setAccordionState((prev) => ({ ...prev, details: !prev.details }))}
          className="shadow-none border-b-0.5 border-[#ecf3fe]"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className="p-0">
            {detailsHeader()}
          </AccordionSummary>
          <AccordionDetails>{detailsContent()}</AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          expanded={accordionState.status}
          onChange={() => setAccordionState((prev) => ({ ...prev, status: !prev.status }))}
          className="shadow-none border-b-0.5 border-[#ecf3fe]"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className="p-0">
            {statusHeader()}
          </AccordionSummary>
          <AccordionDetails>{statusContent()}</AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}

export default FilePropertiesInReviews;
